import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Item } from '../item-detail/item-detail.service';
import { MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ILightBox } from '../item-detail/image-carousel/popup-lightbox/popup-lightbox.component';
import { CommonModule, CurrencyPipe, isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { AppMessageService } from '../../app.message.service';
import { APPHOST } from '../../app.component';
export interface ICartItem {
  productId?:string;
  description?: string;
  quantity?: number;
  warranty?: string;
  unitPrice?: string;
  total?: string;
  icon?: string;
}
@Component({
  selector: 'app-cart-qty-control',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatInputModule, ReactiveFormsModule, FormsModule, MatButtonModule],
  templateUrl: './cart-qty-control.component.html',
  styleUrl: './cart-qty-control.component.scss',
  providers: [
    { provide: MatDialogRef, useValue: {} },
    CurrencyPipe,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } }
  ]
})
export class CartQtyControlComponent {
  product!: Item;
  images = new Set<string>();
  slug = ''
  qty = new FormControl(1)

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private dialogRef: DialogRef<CartQtyControlComponent>,
    @Inject(DIALOG_DATA) public data: ILightBox,
    private currencyPipe: CurrencyPipe,
    private msgService: AppMessageService

  ) {
    this.product = data.product!
    if (this.product.slug === undefined) {

    } else
      this.slug = this.product.slug + '_' + this.product.id

    this.images = data.images!
  }


  addToCart() {

    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('sfncart')) {
        var g: ICartItem[] = JSON.parse(localStorage.getItem('sfncart') as string);
        g.push({
          description: this.product.label,
          unitPrice: this.currencyPipe.transform(this.product.newPrice!.toString(), 'Rs.')!,
          quantity: Number(this.qty.value!.toString()),
          warranty: this.product.warranty,
          icon: this.product.icon,
          total: this.currencyPipe.transform((this.product.newPrice! * this.qty.value!).toString(), 'Rs.')!
        })
        localStorage.setItem('total', g.reduce((c, p) => c + Number(p.total!.replace('Rs.', '').replaceAll(',', '')), 0).toString())
        localStorage.setItem('sfncart', JSON.stringify(g))
        this.msgService.pushNotification('TOTAL', localStorage.getItem('total'))

      } else {
        localStorage.setItem('sfncart', JSON.stringify([]))
        var g: ICartItem[] = JSON.parse(localStorage.getItem('sfncart') as string);

        g.push({
          description: this.product.label,
          unitPrice: this.currencyPipe.transform(this.product.newPrice!.toString(), 'Rs.')!,
          quantity: Number(this.qty.value!.toString()),
          warranty: this.product.warranty,
          icon: this.product.icon,
          total: this.currencyPipe.transform((this.product.newPrice! * this.qty.value!).toString(), 'Rs.')!
        })
        localStorage.setItem('total', g.reduce((c, p) => c + Number(p.total!.replace('Rs.', '').replaceAll(',', '')), 0).toString())

        localStorage.setItem('sfncart', JSON
          .stringify(g))
        this.msgService.pushNotification('TOTAL', localStorage.getItem('total'))

      }
      this.msgService.pushNotification('TOTAL', localStorage.getItem('total'))
    }
    this.dialogRef.close()
  }
  close() {
    this.dialogRef.close()
  }

  reduce() {
    this.qty.setValue(Number(this.qty.value) - 1)
  }
  add() {
    this.qty.setValue(Number(this.qty.value) + 1)

  }
  getHost():string{
    return APPHOST;
  }
}
